export default {"src":"/_next/static/media/signUp.dc78a4e2.svg","height":278,"width":677,"blurWidth":0,"blurHeight":0};